import {AbstractNavPanel} from "@/scenes.ui/abstract-nav-panel";
import Scene = Phaser.Scene;
import {PlayerActionButton} from "@/scenes.ui/player-action-button";
import CU from "@/utils/c-u";

export default class ProfileActionsNavPanel extends AbstractNavPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, x: number, y: number, buttons: PlayerActionButton[]) {
        super(scene, canvas, x, y, buttons, 4);

        this.x = x * CU.S;
        this.y = y * CU.S;

    }

    protected makePanel(x: number, element: any): any {
        element.ignoreDestroy = true;
        element.x = x * CU.S;
        return element;
    }

    protected calculateCellWidth(creaturesAmount: number): number {
        return 120;
    }

    protected getButtonX(): number {
        return 250;
    }

    protected getButtonY(): number {
        return -10;
    }
}